import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconTopUp = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2ZM12.5 7C13.0523 7 13.5 7.44772 13.5 8V11H16.5C17.0523 11 17.5 11.4477 17.5 12C17.5 12.5523 17.0523 13 16.5 13H13.5V16C13.5 16.5523 13.0523 17 12.5 17C11.9477 17 11.5 16.5523 11.5 16V13H8.5C7.94771 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94771 11 8.5 11H11.5V8C11.5 7.44772 11.9477 7 12.5 7Z"
      fill={color}
    />
  </svg>
);

IconTopUp.propTypes = {
  color: string,
  size: number,
};

IconTopUp.defaultProps = {
  color: colors.AJAIB_BLUE_5,
  size: 24,
};

export default IconTopUp;
